<template>
  <div class="clientCon">
    <div class="header">
      <!-- 安全规则管理 -->
      <header-tag :title="'安全中心网吧列表'"></header-tag>
      <div class="pa f14" style="left:150px; top:0px;">>> <b class="cp" @click="goBack">{{ $route.query.barName }}({{
          $route.query.barId
      }})</b></div>
      <div class="search fr" style="margin:20px 30px 0 0;">
        <div class="fl errorCol f14" style="line-height:34px;margin-right:10px;">调试日志路径：{{ dir }}</div>
        <Input v-model="barName" style="width: 300px">
        <Select v-model="searchType" slot="prepend" style="width: 120px">
          <Option value="pcName">客户机名称</Option>
          <Option value="ip">客户机IP</Option>
          <Option value="mac">客户机MAC</Option>
          <Option value="os">操作系统</Option>
          <Option value="ver">客户端版本号</Option>
        </Select>
        <Button slot="append" icon="ios-search" @enter="searchFn" @click="searchFn"></Button>
        </Input>
      </div>
    </div>
    <!-- 表格部分 -->
    <div class="pa loadingCon" v-if="loading">
      <no-data style="height:auto;padding-top:20px;padding-bottom:20px;" :loading="true">加载中</no-data>
    </div>
    <div class="table-content tal">
      <Table stripe border ref="selection" :columns="$store.state.user.isDebugAll ? columns2 : columns1" :data="data1"
        @on-selection-change="selectFn">
        <template slot-scope="{row,index}" slot="model">
          <!-- <switchcCom :value="row.debug" @change="debugSwitchFn(row, index)" style="margin-left:6px;">开启</switchcCom> -->
          <i-switch v-model="row.hafman" :disabled="!row.debug" @on-change="switchClientHafman(row)"></i-switch>
        </template>
        <template slot-scope="{row,index}" slot="debug">
          <!-- <switchcCom :value="row.debug" @change="debugSwitchFn(row, index)" style="margin-left:6px;">开启</switchcCom> -->
          <i-switch v-model="row.debug" :before-change="handleBeforeChange.bind(this, row, index)"></i-switch>
        </template>
        <template slot-scope="{row,index}" slot="relur">
          <Button size="small" type="info" class="f12" :disabled="Boolean(!row.debug)" @click="() => {
            getDebugCfgByBarId();
            isEditor = true
          }">编辑</Button>
        </template>
        <template slot-scope="{row,index}" slot="action">
          <Button size="small" type="warning" class="f12" v-if="!row.debug" @click="delFn(row.id, row)">删除</Button>
          <Button size="small" type="info" class="f12" :loading="row.isRestart" @click="restartClient(row)"
            v-if="row.debug">重启</Button>
          <!-- <Button size="small" type="info" :disabled="Boolean(!row.debug)">获取日志</Button> -->
          <!-- <Button size="small" type="info" class="f12" style="margin-left:10px;" :disabled="Boolean(!row.debug)"
            @click="proFn(row)">进程树</Button> -->
          <Button size="small" type="info" class="f12" style="margin-left:10px;"
            @click="proFn2(row)">进程树</Button>
        </template>
      </Table>
      <Page :total="total" :page-size="size" :page-size-opts="[100, 300, 500, 1000]" show-sizer show-total
        @on-change="changeFn" @on-page-size-change="changeSizeFn" class=" fr" style="margin-top:10px;" />
      <!-- <Button @click="handleSelectAll(true)" style="margin-top:10px;">全选</Button>
      <Button @click="handleSelectAll(false)" style="margin:10px 0 0 10px;">取消全选</Button> -->
      <Button :disabled="selectVal.length == 0" @click="delClient" style="margin:10px 0 0 0;">删除客户机<b
          v-if="selectVal.length > 0">(已选{{ selectVal.length
          }})</b></Button>

    </div>
    <div class="mackCon pf pr" v-if="isEditor">
      <div class="inMaskCon pa editorLinshi">
        <div class="title tal pr f14">编辑调试专用规则 <i class="closeIncon f30 pa" @click="isEditor = false">×</i></div>
        <div class="bodyCon">
          <newEditorCom @addRule="addRule" class="tal" style="margin-left:-40px;" />
          <Form :label-width="80">
            <Form-item label="调试规则">
              <textarea class="editTextArea scrollStyle" v-model="ruleText" warp="off" id="" cols="10"
                rows="6"></textarea>
            </Form-item>
          </Form>
        </div>
        <div class="footCon tar">
          <Button type="warning" @click="copy" style="margin-right:10px;" :disabled="ruleText == ''">一键复制</Button>
          <Button @click="isEditor = false">取消</Button>
          <Button style="margin-left:10px;" :loading="btnLoading" type="primary"
            @click="updateDebugRuleByBarId">保存</Button>
        </div>
      </div>
    </div>
    <div class="mackCon pf pr" v-if="isDel">
      <div class="inMaskCon pa">
        <div class="title tal pr f14">编辑[调试规则] <i class="closeIncon f30 pa" @click="isDel = false">×</i></div>
        <div class="bodyCon ">
          <!-- <Form :label-width="80">
            <Form-item label="网吧名称">
              <Input placeholder="请输入" v-model="curData.barName" style="width:300px;"></Input>
            </Form-item>
          </Form> -->
          <span class="f16">您正在编辑<b class="errorCol">{{ $route.query.barId }}-{{ $route.query.barName }}</b>的调试规则</span>
          <p style="padding: 30px 50px;margin-top: 20px; background: #eee;">客户机删除后，如果客户端再次启动则会重新上线！</p>
        </div>
        <div class="footCon tar">
          <Button @click="isDel = false">取消</Button>
          <Button style="margin-left:10px;" :loading="btnLoading" type="primary" @click="delSuren">确定删除</Button>
        </div>
      </div>
    </div>
    <!-- <proCom ref="proCom" :curData="curData" /> -->
    <Modal v-model="modal" title="调试主机参数设置">
      <h3 class="f16 fw tac" style="margin-bottom:10px;">您正在<b class="errorCol"
          v-text="curData.debug ? '关闭调试模式' : '开启调试模式'"></b>功能</h3>
      <template v-if="!curData.debug">
        <p class="tac"> 开启调试模式会影响主机性能，调试结束后请及时关闭调试模式</p>
        <p class="tac errorCol f16" style="margin:10px 0;">调试日志路径：{{ $route.query.logDir }}</p>
        <p style="background:#eee;padding:10px;" class="tac">上述路径用于存储安全中心客户端启动后的所有进程行为信息，执行过的exe、驱动文件。0点后新开客户机将自动使用新路径。
        </p>
      </template>
      <template v-else>
        <div style="background:#eee;padding:15px;" class="tac">
          <p>关闭调试模式后，调试规则仍然保存，但不再生效。</p>
          <p>如需继续使用调试模式编写的规则，请将调试规则保存为正式规则。</p>
        </div>
      </template>
      <div slot="footer">
        <!-- <Checkbox class="fl" :value="Boolean(curData.hafman)" @on-change="switchClientHafman">调试模块程序</Checkbox> -->
        <Button type="info" @click="ok" :loading="isBtnLoading" v-if="!curData.debug">保存并开启调试模式</Button>
        <Button type="info" @click="ok" :loading="isBtnLoading" v-else>保存并关闭调试模式</Button>
        <Button @click="modal = false">取消</Button>
      </div>
    </Modal>
    <proTreeCom ref="proTreeCom" :curData="curData" />
  </div>
</template>
<script>
import HeaderTag from '_c/tagTitle/headerTag'
import { getPageOfClient, switchClientDebug, delClient, restartClient, getDebugCfgByBarId } from '@/requests/selfClient'
import switchcCom from '_c/switch/switch'
import NoData from '_c/noData/noData'
import newEditorCom from '@/components/relue/newEditor.vue'
import { updateDebugRuleByBarId, addDebugRuleByBarId, queryClientOnline, getLogDirOfBar } from '@/requests/debug'
import { switchClientHafman } from '@/requests/agreement'
import proCom from './pro.vue'
import proTreeCom from './proTree.vue'
import { Base64 } from 'js-base64'
export default {
  components: {
    HeaderTag,
    switchcCom,
    NoData,
    newEditorCom,
    proCom,
    proTreeCom
  },
  watch: {
    'inputVal' () {
      if (this.inputVal == '') {
        this.getPageOfClient()
      }
    },
    'barName' () {
      if (this.barName == '') {
        this.getPageOfClient()
      }
    }
    // isEditor () {
    //   if (this.isEditor)
    //   {
    //     this.getDebugCfgByBarId()
    //   }
    // }
  },
  data () {
    return {
      isBtnLoading: false,
      modal: false,
      isEditor: false,
      loading: false,
      btnLoading: false,
      isDel: false,
      curData: '',
      barName: '',
      searchType: 'pcName',
      options: [
        {
          id: 0,
          val: '网吧名称'
        },
        {
          id: 1,
          val: '网吧ID'
        },
        {
          id: 2,
          val: '外网IP'
        },
        {
          id: 3,
          val: '版本'
        }
      ],
      isShowDetail: false,
      placeholder: '请输入网吧名称',
      formInline: {
        barName: ''
      },
      inputVal: '',
      columns1: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: '客户机名称',
          sortable: true,
          key: 'pcName',
          width: 120,
          ellipsis: true,
          render: (h, params) => {
            return h('Tooltip', {
              props: { placement: 'top' }
            }, [
              this.data1[params.index].pcName,
              h('span', {
                slot: 'content',
                style: {
                  whiteSpace: 'normal',
                  wordBreak: 'break-all'
                }
              }, this.data1[params.index].pcName)
            ])
          }
        },

        {
          title: '客户机本机IP',
          key: 'ip',
          sortable: true,
          width: 120,
          align: 'center'
        },

        {
          title: '客户机本机MAC',
          key: 'mac',
          align: 'center',
          sortable: true,
          width: 130,
        },
        // {
        //   title: '首次上线时间',
        //   key: 'firstTime',
        //   align: 'center',
        //   sortable: true,
        //   width: 130,
        //   align: 'center'
        // },
        {
          title: '最后上线时间',
          key: 'lastTime',
          align: 'center',
          sortable: true,
          width: 130,
        },
        {
          title: '操作系统',
          key: 'os',
          align: 'center',
          width: 120,
          sortable: true,
          // render: (h, params) => {
          //   let txt = ''
          //   if (params.row.os == '10.0')
          //   {
          //     txt = 'Win10'
          //   } else
          //   {
          //     txt = 'Win7'
          //   }
          //   return h("div", {
          //     props: {}
          //   },
          //     txt);
          // }
        },
        {
          title: '版本',
          key: 'ver',
          align: 'center',
          width: 80,
          sortable: true,
        },
        {
          title: '调试主机',
          key: 'debug',
          width: 70,
          slot: 'debug',
          align: 'center',
        },
        {
          title: '调试专用规则',
          key: 'relur',
          width: 90,
          slot: 'relur',
          align: 'center',
        },
        {
          title: '操作',
          key: 'action',
          align: 'center',
          slot: 'action'
        },
      ],
      columns2: [
        {
          type: 'selection',
          width: 40,
          align: 'center'
        },
        {
          title: '客户机名称',
          sortable: true,
          key: 'pcName',
          width: 120,
          ellipsis: true,
          render: (h, params) => {
            return h('Tooltip', {
              props: { placement: 'top' }
            }, [
              this.data1[params.index].pcName,
              h('span', {
                slot: 'content',
                style: {
                  whiteSpace: 'normal',
                  wordBreak: 'break-all'
                }
              }, this.data1[params.index].pcName)
            ])
          }
        },

        {
          title: '客户机本机IP',
          key: 'ip',
          sortable: true,
          width: 110,
          align: 'center'
        },

        {
          title: '客户机本机MAC',
          key: 'mac',
          align: 'center',
          sortable: true,
          width: 130,
          align: 'center'
        },

        {
          title: '首次上线时间',
          key: 'firstTime',
          align: 'center',
          sortable: true,
          width: 130,
          align: 'center'
        },
        {
          title: '最后上线时间',
          key: 'lastTime',
          align: 'center',
          sortable: true,
          width: 130,
          align: 'center'
        },
        {
          title: '操作系统',
          key: 'os',
          align: 'center',
          width: 120,
          sortable: true,
          // render: (h, params) => {
          //   let txt = ''
          //   if (params.row.os == '10.0')
          //   {
          //     txt = 'Win10'
          //   } else
          //   {
          //     txt = 'Win7'
          //   }
          //   return h("div", {
          //     props: {}
          //   },
          //     txt);
          // }
        },
        {
          title: '版本',
          key: 'ver',
          align: 'center',
          width: 80,
          sortable: true,
        },
        {
          title: '调试主机',
          key: 'debug',
          width: 70,
          slot: 'debug',
          align: 'center',
        },
        {
          title: '调试模块',
          key: 'model',
          width: 70,
          slot: 'model',
          align: 'center',
        },
        {
          title: '调试专用规则',
          key: 'relur',
          width: 90,
          slot: 'relur',
          align: 'center',
        },
        {
          title: '操作',
          key: 'action',
          slot: 'action'
        },
      ],
      data1: [
      ],
      num: 1,
      size: 1000,
      total: 0,
      selectVal: [],
      isRestart: false,
      curId: '',
      ruleText: '',
      isFirst: true,
      resolve: '',
      dir: this.$route.query.logDir
    }
  },
  mounted () {
    this.getPageOfClient()
    this.getLogDirOfBar()
  },
  methods: {
    async getLogDirOfBar () {
      let res = await getLogDirOfBar({
        barId: this.$route.query.barId
      })
      if (res.code == 200) {
        this.dir = res.data
      }
    },
    async switchClientHafman (row) {
      let res = await switchClientHafman({
        id: row.id
      })
      this.getPageOfClient()
    },
    handleBeforeChange (row) {
      this.curData = row
      return new Promise((resolve) => {
        this.resolve = resolve
        // this.$Modal.confirm({
        //   title: '切换确认',
        //   content: `<p>teshi</p><Checkbox v-model="${row.hafman}"></Checkbox>`,
        //   onOk: () => {
        //     resolve();
        //     console.log(resolve)
        //   }
        // });
        this.modal = true
      })
    },
    ok () {
      this.isBtnLoading = true
      this.debugSwitchFn(this.curData, this.resolve)
      // this.resolve()
      // this.modal = false
    },
    proFn (val) {
      this.curData = ''
      this.$refs.proCom.visible = true
      this.curData = val
    },
    async proFn2 (val) {
      this.curData = ''
      // this.$refs.proTreeCom.visible = true
      // this.curData = val
      // let url = this.$router.resolve({
      //   path: '/home/securityCenter/index/dll',
      // })

      this.curData = val
      this.curData.barName = this.$route.query.barName
      let json = ''
      let res = await queryClientOnline({
        barId: this.curData.barId,
        hash: this.curData.hash,
        osStartTime: ''
      })
      if (res.code == 200) {
        if (res.data.maxOsStartTime && res.data) {
          json = {
            barId: this.curData.barId,
            barName: this.curData.barName,
            pcName: this.curData.pcName,
            id: this.curData.id,
            debug: this.curData.debug,
            hash: this.curData.hash,
            osStartTime: res.data.maxOsStartTime
          }
        } else {
          json = {
            barId: this.curData.barId,
            barName: this.curData.barName,
            pcName: this.curData.pcName,
            id: this.curData.id,
            debug: this.curData.debug,
            hash: this.curData.hash,
            osStartTime: this.curData.lastTime
          }
        }
      } else {
        json = {
          barId: this.curData.barId,
          barName: this.curData.barName,
          pcName: this.curData.pcName,
          id: this.curData.id,
          debug: this.curData.debug,
          hash: this.curData.hash,
          osStartTime: this.curData.lastTime
        }
      }
      window.open('/v2/home/tree' + '?curData=' + JSON.stringify(json), '_blank', 'width=1000,height=800,left=100,top=100')
    },
    async getDebugCfgByBarId () {
      let res = await getDebugCfgByBarId({
        id: this.$route.query.barId
      })
      if (res.code == 200) {
        let json = JSON.parse(res.data)
        console.log(json)
        this.ruleText = json[0].rule
        if (this.ruleText == '') {
          this.isFirst = true
        } else {
          this.isFirst = false
        }
      }
    },
    async updateDebugRuleByBarId () {
      const bolb = new Blob([this.ruleText], {type: 'text/plain'})
      const sizeInBytes = bolb.size
      const sizeInkb = sizeInBytes / 1024
      if (sizeInkb > 64) {
        return this.$Message.error('规则内容长度不能大于64KB');
      }
      let res = await updateDebugRuleByBarId(
        this.$route.query.barId,
        1000000000,
        this.ruleText
      )
      if (res.code == 200) {
        this.isEditor = false
        this.$Notice.success({ title: '保存成功' })
      } else {
        window.$Message.show({
          title: '提示',
          type: 'error',
          msg: res.msg,
        })
      }
      // if (this.isFirst)
      // {
      //   let res = await addDebugRuleByBarId(
      //     this.$route.query.barId,
      //     1000000000,
      //     this.ruleText
      //   )
      //   if (res.code == 200)
      //   {
      //     this.isEditor = false
      //     this.$Notice.success({ title: '保存成功' })
      //     this.isFirst = false
      //   } else
      //   {
      //     window.$Message.show({
      //       title: '提示',
      //       type: 'error',
      //       msg: res.msg,
      //     })
      //   }
      // } else
      // {

      // }
    },
    copy () {
      this.$copyText(this.ruleText).then(
        function (e) {
          return window.$msg({
            showClose: true,
            type: 'success',
            message: '复制成功'
          })
          //   alert('复制成功')
        },
        function (e) {
          //   alert('复制失败')
        }
      )
    },
    addRule (val) {
      // console.log(val)
      // let arr = val.split(/\s+/)
      // arr.forEach(el => {
      //   let index = this.ruleText.indexOf(el)
      //   console.log(index)
      //   if (index == -1)
      //   {
      //     this.ruleText = el + '\n' + this.ruleText
      //   }
      // })
      let arr = val.split('\n')
      let txt = false
      arr.forEach(el => {
        let rule = this.ruleText.split('\n')
        let index = rule.findIndex(val => val == el)
        if (index == -1) {
          this.ruleText = el + '\n' + this.ruleText
        } else {
          if (rule[index].indexOf('//') == 0) {
            this.ruleText = el + '\n' + this.ruleText
          } else {
            if (el != '') {
              txt = true
            }
          }
        }
      })
      if (txt) {
        this.$Notice.warning({
          desc: '添加失败，当前规则已经存在。'
        })
      }
    },
    async delSuren () {
      this.btnLoading = true
      let res = await delClient({
        ids: this.curId
      })
      this.btnLoading = false
      if (res.code == 200) {
        this.getPageOfClient()
        this.isDel = false
        this.$Notice.success({
          desc: '所选客户机删除成功，如对应终端再次运行客户端，将会重新显示！'
        })
      }
    },
    async restartClient (item) {
      item.isRestart = true
      let res = await restartClient({
        id: item.id
      })
      setTimeout(() => {
        item.isRestart = false
      }, 1000 * 60)
    },
    searchFn () {
      this.getPageOfClient()
    },
    async delFn (id, item) {
      if (item.debug) {
        this.isDel = true
        this.curId = id
      } else {
        let res = await delClient({
          ids: id
        })
        if (res.code == 200) {
          this.$Notice.success({
            desc: '所选客户机删除成功，如对应终端再次运行客户端，将会重新显示！'
          })
          this.getPageOfClient()
        } else {
          this.$Notice.warning({
            title: res.msg
          })
        }
      }
    },
    async debugSwitchFn (row, func) {
      let res = await switchClientDebug({
        id: row.id
      })
      this.isBtnLoading = false
      if (res.code == 200) {
        this.getPageOfClient()

        func()
        this.modal = false
        // this.getPageOfClient()
        // this.$Notice.success({
        //   title: '所选客户机删除成功，如对应终端再次运行客户端，将会重新显示！'
        // })
      } else {
        this.$Notice.warning({
          title: res.msg
        })
      }
    },
    async delClient () {
      let ids = ''
      this.selectVal.forEach(el => {
        if (ids != '') {
          ids += ',' + el.id
        } else {
          ids += el.id
        }
      })
      let res = await delClient({
        ids: ids
      })
      if (res.code == 200) {
        this.$Notice.success({
          desc: '所选客户机删除成功，如对应终端再次运行客户端，将会重新显示！'
        })
        this.getPageOfClient()
      } else {
        // consolee.log(121)
        // this.$Message.error(res.msg)
      }
    },
    selectFn (val) {
      this.selectVal = val
      console.log(val)
    },
    goBack () {
      this.$router.go(-1)
    },
    selectOptionFn () {
      this.placeholder = `请输入${this.options[this.selectVal].val}`
    },
    changeFn (val) {
      this.num = val
      console.log(val)
      this.getPageOfClient()
    },
    changeSizeFn (val) {
      this.size = val
      this.getPageOfClient()
    },
    async getPageOfClient () {
      this.loading = true
      this.data1 = []
      let json = {
        barId: this.$route.query.barId
      }; let val = ''
      json[this.searchType] = this.barName
      val = encodeURIComponent(JSON.stringify(json))
      let res = await getPageOfClient({
        num: this.num,
        size: this.size,
        client: val
      })
      this.loading = false
      console.log(res)
      if (res.code == 200) {
        res.data.records.forEach(el => {
          el._disabled = false
          if (el.debug) {
            el._disabled = true
          }
        })
        res.data.records.forEach(el => {
          el.isRestart = false
        })
        res.data.records.forEach(el => {
          if (el.debug) {
            el.debug = true
          } else {
            el.debug = false
          }
          if (el.hafman) {
            el.hafman = true
          } else {
            el.hafman = false
          }
        })
        this.data1 = res.data.records
        this.total = Number(res.data.total)
      }
    },
    handleSelectAll (val) {
      this.$refs.selection.selectAll(val)
    },
    show (index) {
      console.log(index)
      this.isShowDetail = true
    }
  }
}
</script>
<style lang="scss" scoped>
.header {
  padding-left: 30px;
  text-align: left;
  position: relative;
  z-index: 10;
  height: 70px;
  line-height: 70px;
  border-bottom: 1px solid #d9dee4;
}

.right {
  float: right;
  padding-right: 20px;

  a {
    margin-left: 6px;
    line-height: normal;
  }
}

.table-content {
  padding-top: 10px;
  padding-left: 30px;
  padding-right: 30px;
  font-size: 12px !important;

}

.table-pagination {
  text-align: right;
  padding-right: 80px;
  padding-top: 20px;

  >div {
    display: inline-block;
  }
}

.search {
  display: inline-block;
  height: 30px;

  input {
    width: 200px;
    line-height: 30px;
    text-indent: 10px;
    border: 1px solid #eee;
  }

  margin-left: 20px;

  a {
    height: 32px;
    background: #eee;
    width: 32px;
    text-align: center;
    line-height: 32px;
    top: 12px;
  }
}

.table-content {
  .search {
    margin: 10px 0;
  }

  ul {
    li {
      width: 14%;
      text-align: center;
      padding: 10px;

      div {
        background: #eee;
        line-height: 40px;
      }

      b {
        color: limegreen;
        font-size: 18px;
      }
    }
  }

  select {
    line-height: 30px;
    height: 30px;
    width: 120px;
    border: 1px solid #eee;
    margin-right: 10px;
  }

  input {
    margin-right: 10px;
  }
}

.search {
  display: inline-block;
  height: 30px;

  input {
    width: 200px;
    line-height: 30px;
    text-indent: 10px;
    border: 1px solid #eee;
  }

  margin-left: 20px;

  a {
    height: 32px;
    background: #eee;
    width: 32px;
    text-align: center;
    line-height: 32px;
    top: 12px;
  }
}

.loadingCon {
  width: 100%;
  height: 100%;
  background: rgba($color: #fff, $alpha: .3);
  z-index: 9;
}

.editTextArea {
  border: 1px solid #eee;
  width: 1060px;
  padding: 10px;
  line-height: 20px;
  min-height: 300px;
  font-size: 13px;
  font-family: emoji,inherit;
}
</style>
<style lang="scss">
.clientCon {
  .ivu-tooltip .ivu-tooltip-rel {
    width: 120px !important;
  }

  .ivu-table-cell {
    padding: 0 4px !important;
  }

  .clientCon {
    .ivu-table-cell-slot {
      margin-left: 0 !important;
    }

    .ivu-table-header thead tr th {
      height: 100% !important;
      padding: 8px 0 !important;
    }

  }

  .editorLinshi {
    width: 1200px;

    .ivu-btn-group {
      margin-left: 120px;
    }

    .ivu-select {
      width: 140px !important;
    }

    .ivu-input-wrapper {
      width: 240px !important;
    }

  }
}
</style>